export default class OrderRowData {
    constructor(params) {
        var me = this;
        let now = new Date();

        me.id = 0;
        me.oid = 0;
        /*
            me.codiceProd verrà messo in pid del record riga ordine = è il nuovo
            me.codSost verrà messo in spi del record riga ordine = è il vecchio
            me.descrizione verrà messo in ide del record riga ordine = è la descrizione nuova

            prodotti inseriti da distinta hanno queste proprietà in refObj:
                sid: codice vecchio
                des: descrizione vecchia
                spi: codice nuovo
                spdes: descrizione nuova

            prodotti inseriti da carrello (se viene da registry) hanno queste proprietà in refObj:
                id: codice nuovo 
                des: descrizione nuova
                spi: codice vecchio
                spo: oggetto prodotto vecchio

            prodotti inseriti da carrello (se viene da catalog) hanno queste proprietà in refObj:
                id: codice vecchio 
                des: descrizione vecchia
                newId: codice nuovo 
                newDes: descrizione nuova

        */
        if(params && params.refObj && params.refObj.spi){ //da distinta quando ha sostitutivo
            me.codiceProd = params.refObj.spi
            me.codSost = params.refObj.sid
            me.descrizione = params.refObj.spdes
        }else if(params && params.refObj && params.refObj.spi && params.refObj.spo){ //da ricerca carrello registry
            me.codiceProd = params.refObj.id
            me.codSost = params.refObj.spi
            me.descrizione = params.refObj.des
        }else if(params && params.refObj && params.refObj.newId && params.refObj.newDes){ //da ricerca carrello catalog
            me.codiceProd = params.refObj.newId
            me.codSost = params.refObj.id
            me.descrizione = params.refObj.newDes
        }else{ //da distinta senza sostitutivo
            me.codiceProd = params ? params.cod : ''; 
            me.codSost = ''; 
            me.descrizione = params ? params.descr : '';    
        }
        //params.unitmis
        me.unitaMisura = params && params.refObj ? params.refObj.uni ? params.refObj.uni : params.refObj.unitaMisura ? params.refObj.unitaMisura : 'NR' : 'NR';  // unità di misura ['HH', 'MC','LT','MT','KG','ML','NR','MQ','GR','MM']
        me.quantita = params ? params.qty : 1; 
        me.prezzoUnitario = params ? params.prezzoUnitario : 0; 
        me.prezzoTotale = params ? params.prezzoTotale : 0; 
        me.prezzoOriginario = params ? params.prezzoOriginario : 0; 
        me.discount = params ? params.discount : 0; 
        me.statoProdotto = params ? params.statoProdotto : ''; // StatoRiga:  ['In ordine', 'Richiesta in garanzia', 'Richiesta in garanzia con accredito', 'In garanzia', 'Da quotare', 'Quotata', 'Evasa', 'cancellata', 'Non disponibile', 'Spedita'] 
        me.dataModifica = now; 
        me.dataUltimaModifica = now;  
        me.csy = params ? params.csy : '';                       
        me.mqt = params ? params.refObj.mqt : '';  
        me.mqd = params ? params.refObj.mqd : null;  
        me.pib = params ? params.refObj.pib : null;
        me.codlinea = params ? params.codlinea : '';
        me.codmacch = params ? params.codmacch : '';
        me.desmacch = params ? params.desmacch : '';
        me.scontoArticolo = params ? params.scontoArticolo : null;
        me.scontoCliente = params ? params.scontoCliente : null;
        me.noteRiga = params ? params.noteRiga : '';
        me.statoDisponibilità = params ? params.statoDisponibilità : '';
    }
}




// WEBPACK FOOTER //
// ./src/components/views/shopcart/OrderRowData.js